const EMAIL_PATTERN = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
const SSN_PATTERN = /\b\d{3}-\d{2}-\d{4}\b/g;
const CARD_PATTERN = /\b(?:\d[ -]?){13,19}\b/g;
// US-style phone numbers - matches "(303) 555-1234", "303-555-1234", "303.555.1234",
// "3035551234", and optional leading "+1" / "1-". Uses digit lookbehind/lookahead
// instead of \b so leading "(" and "+" get absorbed into the match (\b only fires
// between word + non-word chars, so "+1 …" would otherwise leave the "+" stranded).
// Run BEFORE the card pattern via the chained replace so phone digit-runs don't
// get gobbled by the card matcher.
const PHONE_PATTERN = /(?<!\d)(?:\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}(?!\d)/g;

const REDACTED = "[REDACTED]";

export function scrubQueryClient(text: string): string {
  return text
    .replace(EMAIL_PATTERN, REDACTED)
    .replace(SSN_PATTERN, REDACTED)
    .replace(PHONE_PATTERN, REDACTED)
    .replace(CARD_PATTERN, REDACTED);
}
